import api from "../../../lib/axios";
import { apiUtils } from "../../../utils/apiUtils";
import type {
  MerchantBrandAdmin,
  MerchantBrandCatalogListItem,
  MerchantBrandCategoryPatchPayload,
  MerchantBrandStatusPatchPayload,
} from "../types/merchantBrandAdmin.types";

const catalogEndpoint = "/v1/portal/merchant-brand";
const adminEndpoint = "/v1/portal/merchant-brands";

type CatalogListParams = {
  keyword?: string;
};

export function getMerchantBrandCatalog(params: CatalogListParams) {
  return apiUtils.getData<MerchantBrandCatalogListItem[]>(
    catalogEndpoint,
    "Failed to load merchant brands",
    { params },
  );
}

export function getMerchantBrandAdmin(id: string) {
  return apiUtils.getData<MerchantBrandAdmin>(
    `${adminEndpoint}/${id}`,
    "Failed to load merchant brand",
  );
}

export function updateMerchantBrandCategories(
  id: string,
  payload: MerchantBrandCategoryPatchPayload,
) {
  return apiUtils.patchData<MerchantBrandAdmin, MerchantBrandCategoryPatchPayload>(
    `${adminEndpoint}/${id}/categories`,
    payload,
    "Failed to update merchant brand categories",
  );
}

export function updateMerchantBrandStatus(id: string, payload: MerchantBrandStatusPatchPayload) {
  return apiUtils.patchData<MerchantBrandAdmin, MerchantBrandStatusPatchPayload>(
    `${adminEndpoint}/${id}/status`,
    payload,
    "Failed to update merchant brand status",
  );
}
